var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"moreButton",attrs:{"outlined":"","height":"3.5vw","width":"10.5vw"}},[_vm._v("More")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }